import axios from 'axios';
import Middlewares from '../middleware';
import { AuthService } from './auth.service';

export default class AxiosApiService {
  constructor(url) {
    this.url = url;

    let token = AuthService.getToken();
    if (token && token !== null) {
      this.setToken(token);
    } else {
      this.axios = axios.create({
        baseURL: url,
        timeout: 200000
      });
    }

    this.axios.interceptors.response.use((response) => {
      return response;
    }, Middlewares.ParseError);
  }

  setToken(token) {
    this.axios = axios.create({
      baseURL: this.url,
      timeout: 200000,

      headers: {
        authorization: `Bearer ${token}`
      }
    });

    this.axios.interceptors.response.use((response) => {
      return response;
    }, Middlewares.ParseError);
  }

  common(...params) {
    return this.axios(...params);
  }

  get(...params) {
    return this.axios.get(...params).then((res) => res.data);
  }
  post(...params) {
    return this.axios.post(...params).then((res) => res.data);
  }
  put(...params) {
    return this.axios.put(...params).then((res) => res.data);
  }
  delete(...params) {
    return this.axios.delete(...params).then((res) => res.data);
  }
}
